import { Star, Sparkles } from 'lucide-react';

// Anti-gaming : la note n'est affichée qu'à partir de 3 avis révélés.
// En dessous, badge neutre "Nouveau sur Festin" — pas de note à 5★ gonflée
// par un seul avis complaisant.
export function RatingBadge({ rating }: { rating?: { avg: number; count: number } | null }) {
  if (rating && rating.count >= 3) {
    return (
      <span className="inline-flex items-center gap-1.5 bg-[#FF5C00]/10 border border-[#FF5C00]/20 text-[#FF5C00] text-xs font-black px-3 py-1.5 rounded-full">
        <Star className="w-3.5 h-3.5 fill-[#FF5C00]" />
        {rating.avg.toFixed(1)}
        <span className="text-[#FF5C00]/60 font-medium">({rating.count} avis)</span>
      </span>
    );
  }
  return (
    <span className="inline-flex items-center gap-1.5 bg-blue-500/10 border border-blue-500/20 text-blue-400 text-xs font-bold px-3 py-1.5 rounded-full">
      <Sparkles className="w-3.5 h-3.5" />
      Nouveau sur Festin
    </span>
  );
}
